module.exports = __webpack_public_path__ + "img/34_19.b8a723a1.png";